// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { EquipmentsService } from '../../services/equipments.service';
import { GetEquipmentAutoCompleteList, GetEquipmentList } from './equipments.actions';
import { EQUIPMENTS_STATE_DEFAULT, EquipmentsStateModel } from './equipments.model';

@State({ name: 'Equipments', defaults: EQUIPMENTS_STATE_DEFAULT })
@Injectable()
export class EquipmentsState {

  constructor(private service: EquipmentsService) {
  }

  @Selector()
  static equipmentList(state: EquipmentsStateModel): EquipmentsStateModel['equipmentList'] {
    return state?.equipmentList;
  }

  @Selector()
  static equipmentAutoCompleteList(state: EquipmentsStateModel): EquipmentsStateModel['equipmentList'] {
    return state?.equipmentAutoCompleteList;
  }


  @Selector()
  static loadEquipmentListStatus(state: EquipmentsStateModel): EquipmentsStateModel['loadEquipmentListStatus'] {
    return state.loadEquipmentListStatus;
  }


  @Action(GetEquipmentList)
  getEquipmentList(ctx: StateContext<EquipmentsStateModel>, { search, onlyWithPreparedForUse }: GetEquipmentList): void {
    ctx.patchState({
      loadEquipmentListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getEquipmentList(search, false).subscribe({
      next: (data) => {
        ctx.patchState({
          equipmentList: data,
          loadEquipmentListStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: () => {
        ctx.patchState({
          loadEquipmentListStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }

  @Action(GetEquipmentAutoCompleteList)
  getEquipmentAutoCompleteList(ctx: StateContext<EquipmentsStateModel>, { search, onlyWithPreparedForUse }: GetEquipmentList): void {
    ctx.patchState({
      loadEquipmentListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getEquipmentList(search, true).subscribe({
      next: (data) => {
        ctx.patchState({
          equipmentAutoCompleteList: data,
          loadEquipmentListStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: () => {
        ctx.patchState({
          loadEquipmentListStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }
}


